import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  ZoomableGroup,
} from "react-simple-maps";
import { getCountryInfo } from "../../../../../helper/utility";

const geoUrl = "/features.json";

// const AudienceChart = ({ zoom, setZoom }) => {
//   const [tooltip, setTooltip] = useState({
//     show: false,
//     content: "",
//     coords: [0, 0],
//   });
//   const [position, setPosition] = useState({ coordinates: [0, 0], zoom: zoom });
//   const [activeMarker, setActiveMarker] = useState(null);
//   const projectionRef = useRef();

//   // Redux selector
//   const audienceDetails = useSelector((state) => state.dataanalyst);
//   const { radioGeoStats } = audienceDetails;
//   const geoData = radioGeoStats?.length > 0 ? radioGeoStats : [];

//   useEffect(() => {
//     setPosition((pos) => ({ ...pos, zoom }));
//   }, [zoom]);

//   const handleMarkerEvent = (marker, content) => {
//     const proj = projectionRef.current;
//     if (proj) {
//       const [x, y] = proj([marker.longitude, marker.latitude]);
//       setActiveMarker(marker);
//       setTooltip({
//         show: true,
//         content,
//         coords: [x, y],
//       });
//     }
//   };

//   const handleMoveEnd = (position) => {
//     setPosition(position);
//     if (activeMarker && projectionRef.current) {
//       const [x, y] = projectionRef.current([
//         activeMarker.longitude,
//         activeMarker.latitude,
//       ]);
//       setTooltip((prev) => ({
//         ...prev,
//         coords: [x, y],
//       }));
//     }
//   };

//   const handleZoomIn = () => {
//     if (position.zoom >= 8) return;
//     setPosition((pos) => {
//       const newZoom = pos.zoom * 1.5;
//       setZoom(newZoom);
//       return { ...pos, zoom: newZoom };
//     });
//   };

//   const handleZoomOut = () => {
//     if (position.zoom <= 1) return;
//     setPosition((pos) => {
//       const newZoom = pos.zoom / 1.5;
//       setZoom(newZoom);
//       return { ...pos, zoom: newZoom };
//     });
//   };

//   const maxVal = Math.max(...geoData?.map((d) => d.totalPlays));
//   const scale = (value) =>
//     Math.sqrt(value / maxVal) * (10 / (position.zoom || 1));

//   const getCountryColor = (totalPlays) => {
//     if (!totalPlays) return "#FFFFFF";
//     if (totalPlays > 10) return "rgba(255, 69, 0, 0.6)";
//     if (totalPlays > 5) return "rgba(255, 140, 0, 0.5)";
//     if (totalPlays > 1) return "rgba(255, 165, 0, 0.4)";
//     return "rgba(255, 200, 124, 0.3)";
//   };

//   const getCityColor = (totalPlays) => {
//     if (totalPlays > 100) return "rgba(255, 69, 0, 0.8)";
//     if (totalPlays > 50) return "rgba(255, 140, 0, 0.8)";
//     if (totalPlays > 10) return "rgba(255, 165, 0, 0.8)";
//     return "rgba(255, 200, 124, 0.8)";
//   };

//   return (
//     <div className="relative">
//       <ComposableMap
//         projection="geoMercator"
//         projectionConfig={{ scale: 90 }}
//         ref={projectionRef}
//       >
//         <ZoomableGroup
//           zoom={position.zoom}
//           center={position.coordinates}
//           onMoveStart={() => setTooltip((prev) => ({ ...prev, show: false }))}
//           onMoveEnd={handleMoveEnd}
//           maxZoom={8}
//           dragging={false}
//           onWheelZoom={(e) => {
//             if (e.deltaY < 0) handleZoomIn();
//             else handleZoomOut();
//           }}
//         >
//           <Geographies geography={geoUrl}>
//             {({ geographies, projection }) => {
//               projectionRef.current = projection;
//               return geographies.map((geo) => {
//                 const countryData = geoData.find(
//                   (c) =>
//                     getCountryInfo(c.topCountry).name === geo.properties.name
//                 );

//                 return (
//                   <Geography
//                     key={geo.rsmKey}
//                     geography={geo}
//                     fill={getCountryColor(countryData?.totalPlays)}
//                     stroke="#fe3d00"
//                     strokeWidth={0.85}
//                     style={{
//                       default: {
//                         outline: "none",
//                         cursor: countryData ? "pointer" : "default",
//                         transition: "all 250ms",
//                       },
//                       hover: {
//                         fill: countryData
//                           ? "rgba(255, 140, 0, 0.7)"
//                           : "#FFFFFF",
//                         outline: "none",
//                         cursor: countryData ? "pointer" : "default",
//                       },
//                       pressed: {
//                         outline: "none",
//                       },
//                     }}
//                     onMouseEnter={(evt) => {
//                       if (countryData) {
//                         const bounds = evt.target.getBoundingClientRect();
//                         const x = bounds.left + bounds.width / 2;
//                         const y = bounds.top;

//                         setTooltip({
//                           show: true,
//                           content: `${
//                             getCountryInfo(countryData.topCountry).flag
//                           } ${getCountryInfo(countryData.topCountry).name}
//                             🎧 Total Plays: ${countryData.totalPlays.toLocaleString()}
//                             📡 Radio Stations: ${countryData.totalStations}
//                             ⭐ Top Track: ${countryData.topTrack?.title || "-"}
//                             🏆 Top Station: ${
//                               countryData.topStation?.station_name || "-"
//                             }
//                             ${
//                               countryData.cities?.length
//                                 ? `🏙️ Cities Playing: ${countryData.cities.length}`
//                                 : ""
//                             }`,
//                           coords: [x, y],
//                         });
//                       }
//                     }}
//                     onMouseMove={(evt) => {
//                       if (countryData) {
//                         const bounds = evt.target.getBoundingClientRect();
//                         const x = bounds.left + bounds.width / 2;
//                         const y = bounds.top;

//                         setTooltip((prev) => ({
//                           ...prev,
//                           coords: [x, y],
//                         }));
//                       }
//                     }}
//                     onMouseLeave={() => {
//                       setTooltip((prev) => ({ ...prev, show: false }));
//                     }}
//                   />
//                 );
//               });
//             }}
//           </Geographies>

//           {/* Country + City markers */}
//           {geoData.map((country) =>
//             country.cities?.map((city, idx) => (
//               <Marker
//                 key={`${country.topCountry}-${idx}`}
//                 coordinates={[
//                   parseFloat(city.city_lng),
//                   parseFloat(city.city_lat),
//                 ]}
//                 onMouseEnter={() =>
//                   handleMarkerEvent(
//                     {
//                       longitude: city.city_lng,
//                       latitude: city.city_lat,
//                     },
//                     `🏙️ ${city.city_name}, ${
//                       getCountryInfo(country.topCountry).name
//                     }
//                     🎧 ${city.totalPlays.toLocaleString()} Plays
//                     📡 ${city.totalTracks} Tracks
//                     ${city.city_region ? `📍 ${city.city_region}` : ""}`
//                   )
//                 }
//                 onMouseLeave={() =>
//                   setTooltip((prev) => ({ ...prev, show: false }))
//                 }
//               >
//                 <circle
//                   r={scale(city.totalPlays)}
//                   fill={getCityColor(city.totalPlays)}
//                   stroke="#ff0000"
//                   strokeWidth={0.8}
//                   style={{
//                     transition: "all 300ms",
//                     cursor: "pointer",
//                   }}
//                 />
//               </Marker>
//             ))
//           )}
//         </ZoomableGroup>
//       </ComposableMap>

//       {/* Tooltip */}
//       {tooltip.show && (
//         <div
//           className="absolute bg-white px-3 py-2 rounded-lg shadow-lg text-sm text-gray-700 pointer-events-none z-50 border border-gray-200"
//           style={{
//             left: `${tooltip.coords[0]}px`,
//             top: `${tooltip.coords[1]}px`,
//             transform: "translate(-50%, -120%)",
//             whiteSpace: "pre-line",
//             minWidth: "200px",
//             backdropFilter: "blur(8px)",
//             backgroundColor: "rgba(255, 255, 255, 0.95)",
//           }}
//         >
//           {tooltip.content}
//         </div>
//       )}
//     </div>
//   );
// };

const AudienceChart = ({ zoom, setZoom }) => {
  const [tooltip, setTooltip] = useState({
    show: false,
    content: "",
    coords: [0, 0],
  });
  const [position, setPosition] = useState({ coordinates: [0, 0], zoom: zoom });
  const [activeMarker, setActiveMarker] = useState(null);
  const projectionRef = useRef();

  // Redux selector
  const audienceDetails = useSelector((state) => state.dataanalyst);
  const { radioGeoStats } = audienceDetails;
  const geoData = radioGeoStats?.length > 0 ? radioGeoStats : [];

  useEffect(() => {
    setPosition((pos) => ({ ...pos, zoom }));
  }, [zoom]);

  const handleMarkerEvent = (marker, content) => {
    const proj = projectionRef.current;
    if (proj) {
      const [x, y] = proj([marker.longitude, marker.latitude]);
      setActiveMarker(marker);
      setTooltip({
        show: true,
        content,
        coords: [x, y],
      });
    }
  };

  const handleMoveEnd = (position) => {
    setPosition(position);
    setZoom(position.zoom); // Sync zoom with parent
    if (activeMarker && projectionRef.current) {
      const [x, y] = projectionRef.current([
        activeMarker.longitude,
        activeMarker.latitude,
      ]);
      setTooltip((prev) => ({
        ...prev,
        coords: [x, y],
      }));
    }
  };

  const handleZoomIn = () => {
    if (position.zoom >= 8) return;
    setPosition((pos) => {
      const newZoom = pos.zoom * 1.5;
      setZoom(newZoom);
      return { ...pos, zoom: newZoom };
    });
  };

  const handleZoomOut = () => {
    if (position.zoom <= 1) return;
    setPosition((pos) => {
      const newZoom = pos.zoom / 1.5;
      setZoom(newZoom);
      return { ...pos, zoom: newZoom };
    });
  };

  const maxVal = Math.max(...geoData?.map((d) => d.totalPlays));
  const scale = (value) =>
    Math.sqrt(value / maxVal) * (10 / (position.zoom || 1));

  const getCountryColor = (totalPlays) => {
    if (!totalPlays) return "#FFFFFF";
    if (totalPlays > 10) return "rgba(255, 69, 0, 0.6)";
    if (totalPlays > 5) return "rgba(255, 140, 0, 0.5)";
    if (totalPlays > 1) return "rgba(255, 165, 0, 0.4)";
    return "rgba(255, 200, 124, 0.3)";
  };

  const getCityColor = (totalPlays) => {
    if (totalPlays > 100) return "rgba(255, 69, 0, 0.8)";
    if (totalPlays > 50) return "rgba(255, 140, 0, 0.8)";
    if (totalPlays > 10) return "rgba(255, 165, 0, 0.8)";
    return "rgba(255, 200, 124, 0.8)";
  };

  return (
    <div className="relative">
      <ComposableMap
        projection="geoMercator"
        projectionConfig={{ scale: 90 }}
        ref={projectionRef}
      >
        <ZoomableGroup
          zoom={position.zoom}
          center={position.coordinates}
          onMoveStart={() => setTooltip((prev) => ({ ...prev, show: false }))}
          onMoveEnd={handleMoveEnd}
          // minZoom={1}
          maxZoom={300}
        >
          <Geographies geography={geoUrl}>
            {({ geographies, projection }) => {
              projectionRef.current = projection;
              return geographies.map((geo) => {
                const countryData = geoData.find(
                  (c) =>
                    getCountryInfo(c.topCountry).name === geo.properties.name
                );

                return (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    fill={getCountryColor(countryData?.totalPlays)}
                    stroke="#fe3d00"
                    strokeWidth={0.85}
                    style={{
                      default: {
                        outline: "none",
                        cursor: countryData ? "pointer" : "default",
                        transition: "all 250ms",
                      },
                      hover: {
                        fill: countryData
                          ? "rgba(255, 140, 0, 0.7)"
                          : "#FFFFFF",
                        outline: "none",
                        cursor: countryData ? "pointer" : "default",
                      },
                      pressed: {
                        outline: "none",
                      },
                    }}
                    onMouseEnter={(evt) => {
                      if (countryData) {
                        const bounds = evt.target.getBoundingClientRect();
                        const x = bounds.left + bounds.width / 2;
                        const y = bounds.top;

                        setTooltip({
                          show: true,
                          content: `${
                            getCountryInfo(countryData.topCountry).flag
                          } ${getCountryInfo(countryData.topCountry).name}
                            🎧 Total Plays: ${countryData.totalPlays.toLocaleString()}
                            📡 Radio Stations: ${countryData.totalStations}
                            ⭐ Top Track: ${countryData.topTrack?.title || "-"}
                            🏆 Top Station: ${
                              countryData.topStation?.station_name || "-"
                            }
                            ${
                              countryData.cities?.length
                                ? `🏙️ Cities Playing: ${countryData.cities.length}`
                                : ""
                            }`,
                          coords: [x, y],
                        });
                      }
                    }}
                    onMouseMove={(evt) => {
                      if (countryData) {
                        const bounds = evt.target.getBoundingClientRect();
                        const x = bounds.left + bounds.width / 2;
                        const y = bounds.top;

                        setTooltip((prev) => ({
                          ...prev,
                          coords: [x, y],
                        }));
                      }
                    }}
                    onMouseLeave={() => {
                      setTooltip((prev) => ({ ...prev, show: false }));
                    }}
                  />
                );
              });
            }}
          </Geographies>

          {/* Country + City markers */}
          {geoData.map((country) =>
            country.cities?.map((city, idx) => (
              <Marker
                key={`${country.topCountry}-${idx}`}
                coordinates={[
                  parseFloat(city.city_lng),
                  parseFloat(city.city_lat),
                ]}
                onMouseEnter={() =>
                  handleMarkerEvent(
                    {
                      longitude: city.city_lng,
                      latitude: city.city_lat,
                    },
                    `🏙️ ${city.city_name}, ${
                      getCountryInfo(country.topCountry).name
                    }
                    🎧 ${city.totalPlays.toLocaleString()} Plays
                    📡 ${city.totalTracks} Tracks
                    ${city.city_region ? `📍 ${city.city_region}` : ""}`
                  )
                }
                onMouseLeave={() =>
                  setTooltip((prev) => ({ ...prev, show: false }))
                }
              >
                <circle
                  r={scale(city.totalPlays)}
                  fill={getCityColor(city.totalPlays)}
                  stroke="#ff0000"
                  strokeWidth={0.8}
                  style={{
                    transition: "all 300ms",
                    cursor: "pointer",
                  }}
                />
              </Marker>
            ))
          )}
        </ZoomableGroup>
      </ComposableMap>

      {/* Tooltip */}
      {tooltip.show && (
        <div
          className="absolute bg-white px-3 py-2 rounded-lg shadow-lg text-sm text-gray-700 pointer-events-none z-50 border border-gray-200"
          style={{
            left: `${tooltip.coords[0]}px`,
            top: `${tooltip.coords[1]}px`,
            transform: "translate(-50%, -120%)",
            whiteSpace: "pre-line",
            minWidth: "200px",
            backdropFilter: "blur(8px)",
            backgroundColor: "rgba(255, 255, 255, 0.95)",
          }}
        >
          {tooltip.content}
        </div>
      )}
    </div>
  );
};

export default AudienceChart;
